var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7105 1.37458C7.52561 1.74423 8.46394 1.74423 9.27906 1.37458C11.1462 0.540516 14.1982 0.967029 14.8806 4.18957C15.5346 7.26046 13.2598 8.51157 13.421 10.6536C13.6579 13.7624 12.7101 16.0182 11.1936 16.0182C8.54925 16.0182 10.388 11.4877 7.99952 11.4877C5.61105 11.4877 7.44979 16.0182 4.80541 16.0182C3.28892 16.0182 2.34112 13.7624 2.57807 10.6536C2.7392 8.51157 0.464463 7.26994 1.11845 4.18957C1.80087 0.967029 4.8528 0.531038 6.71998 1.37458H6.7105Z",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTooth);
export default __webpack_public_path__ + "static/media/ic_tooth.b61eece31be6c289896628b59eb2934a.svg";
export { ForwardRef as ReactComponent };